import type { AxiosInstance } from 'axios'

import type { TableColumnSortDirection } from '@percent/lemonade'
import type { PBPPermissionsExpansion } from '@percent/admin-dashboard/services/pbpResponses'

export type InternalServiceServiceCapabilities = {
  percentClient: AxiosInstance
}

export type InternalService = {
  id: string
  name: string
  description: string | null
  ownerTeam: string
  createdBy: string
  createdAt: string
  updatedAt: string
}

/** The longest name a service may have. */
export const SERVICE_NAME_MAX_LENGTH = 255

export type InternalServicePermission = 'can_read' | 'can_edit' | 'can_delete' | 'can_view_roles' | 'can_set_roles'

export type InternalServiceWithPermissions = InternalService & PBPPermissionsExpansion<InternalServicePermission>

export const INTERNAL_SERVICE_ROLES = ['reader', 'editor', 'owner'] as const
export type InternalServiceRole = typeof INTERNAL_SERVICE_ROLES[number]

export const isInternalServiceRole = (value: string): value is InternalServiceRole =>
  (INTERNAL_SERVICE_ROLES as readonly string[]).includes(value)

export type InternalServiceRoleHolder = {
  id: string
  serviceId: string
  holderId: string
  holderType: 'account' | 'group'
  /** Null for a holder that can no longer hold a role, such as a deleted account. */
  holderName: string | null
  role: InternalServiceRole
  createdBy: string
  createdAt: string
}

export const INTERNAL_SERVICE_SORT_FIELDS = ['name', 'ownerTeam'] as const
export type InternalServiceSortField = typeof INTERNAL_SERVICE_SORT_FIELDS[number]

export type GetInternalServicesProps = {
  pageSize?: number | null
  cursor?: string | null
  search?: string
  sort?: InternalServiceSortField
  direction?: TableColumnSortDirection
}

export type CreateInternalServiceProps = {
  name: string
  ownerTeam: string
  description?: string
}

export type EditInternalServiceProps = {
  id: string
  name?: string
  ownerTeam?: string
  description?: string | null
}

export type InternalServiceRoleProps = {
  serviceId: string
  holderId: string
  role: InternalServiceRole
}

export type RevokeInternalServiceRoleProps = {
  serviceId: string
  holderId: string
}
